<template>
  <div :class="`kpt-restricted-content ${type}`">
    <div :class="`kpt-restricted-content-label ${position}`">{{label}}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    position: {
      type: String,
      default: 'is-top-left'
    },
    type: {
      type: String,
      default: 'is-dark'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';

.kpt-restricted-content {
  border: 1px solid $grey-lighter;
  padding: 12px;
  border-radius: 3px;
  position: relative;

  .kpt-restricted-content-label {
    position: absolute;
    background: white;
    padding: 8px;
    
    &.is-top-left {
      top: -22px;
      left: 24px;
    }
  }

  &.is-dark {
    border-color: $grey-darker;
    .kpt-restricted-content-label {
      color: $grey-darker;
    }
  }

  &.is-danger {
    border-color: $red;
    .kpt-restricted-content-label {
      color: $red;
    }
  }
  
  &.is-warning {
    border-color: $orange;
    .kpt-restricted-content-label {
      color: $orange;
    }
  }

  &.is-success {
    border-color: $green;
    .kpt-restricted-content-label {
      color: $green;
    }
  }
}
</style>
